import { ColumnText } from './column-text';
import { ColumnExtractor } from './extractors/column-extractor';
import { DefaultFormatter } from './formatters/default-formatter';
import { Formatter } from './formatters/formatter.interface';
import { NamedFormatter } from './formatters/named-formatter.interface';

export class ColumnConfig<T extends ColumnExtractor> {
	private static _id: number = 0;

	public static create<T extends ColumnExtractor>(options: ColumnConfigOptions<T>): ColumnConfig<T> {
		return new ColumnConfig(options.label, options.infoBubble, options.extractor, options.id, options.labelFormatter, options.formatters, options.visible);
	}

	constructor(
		public readonly label: ColumnText,
		public readonly infoBubble: ColumnText,
		public readonly extractor: T,
		// reserved ids for ColumnConfig that which enables special formatting rules in <display-table></display-table> are: asOfDate, benchmarkComparison
		public readonly id?: string,
		public readonly labelFormatter: Formatter = DefaultFormatter.instance,
		public readonly formatters: Array<NamedFormatter> = [],
		public readonly visible: boolean = true
	) {
		if (id) {
			this.id = id;
		} else {
			this.id = String(ColumnConfig._id++);
		}

		// check if attributes are unique
		if (formatters) {
			const attribDefs = {};
			for (const attrib of formatters) {
				if (attribDefs[attrib.attributeName()]) {
					throw new Error('Formatter IDs need to be unique!');
				}
				attribDefs[attrib.attributeName()] = 1;
			}
		}
	}
}

export interface ColumnConfigOptions<T extends ColumnExtractor> {
	label?: ColumnText;
	infoBubble?: ColumnText;
	extractor: T;
	id?: string;
	labelFormatter?: Formatter;
	formatters?: Array<NamedFormatter>;
	visible?: boolean;
}
